import { Controller } from "stimulus";

const TRUNCATE_WORDS_NUM = 120;

export default class extends Controller {
  static targets = ["description", "button"];

  connect() {
    this.originalContent = this.descriptionTarget.innerHTML;

    if (this._contentRequiresTruncate(this.originalContent, TRUNCATE_WORDS_NUM)) {
      this.truncatedContent = this._truncateContent(this.originalContent, TRUNCATE_WORDS_NUM);
      this.descriptionTarget.innerHTML = this.truncatedContent;
    } else {
      this.buttonTarget.classList.add("tw-hidden");
    }
  }

  _truncateContent(str, wordsNum) {
    return str.split(/\s+/).slice(0, wordsNum).join(" ") + "...";
  }

  _contentRequiresTruncate(str, wordsNum) {
    return (str.split(/\s+/).length > wordsNum);
  }

  toggle() {
    if (event.currentTarget.dataset.clicked !== "true") {
      this.descriptionTarget.innerHTML = this.originalContent;
      event.currentTarget.dataset.clicked = true;
      event.currentTarget.innerHTML = event.currentTarget.dataset.lessText;
    } else {
      this.descriptionTarget.innerHTML = this.truncatedContent;
      event.currentTarget.dataset.clicked = false;
      event.currentTarget.innerHTML = event.currentTarget.dataset.moreText;
    }
  }
}
